import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Load the favicon and the .htaccess file
import '!file-loader?name=[name].[ext]!./images/favicon.png';
import 'file-loader?name=.htaccess!./.htaccess'; // eslint-disable-line import/extensions

import { ThemeProvider } from '@fountain/fountain-ui-components';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ConnectedRouter } from 'connected-react-router';
import { setupOpenApiClient } from 'openapi';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import ErrorBoundary from 'components/ErrorBoundary';
import { WxCopilotLayoutProvider } from 'components/GlobalNav/context';
import { HireUniversalSearch } from 'components/UniversalSearch';
import WxCueRootHost from 'components/WxCueRootHost';
import App from 'containers/App';
import LanguageProvider from 'containers/LanguageProvider';
import { PostHogRootProvider } from 'containers/PostHogProvider';
import { domainMeta } from 'utils/domainMeta';
import history from 'utils/history';

import configureStore from './configureStore';
import { translationMessages } from './i18n';

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history, {});
const MOUNT_NODE = document.getElementById('app');

setupOpenApiClient();

const render = messages => {
  ReactDOM.render(
    <Provider store={store}>
      <PostHogRootProvider properties={{ product: 'hire', ui: 'recruiter' }}>
        <ThemeProvider>
          <CssBaseline>
            <LanguageProvider messages={messages}>
              <ConnectedRouter history={history}>
                <ErrorBoundary>
                  <WxCopilotLayoutProvider>
                    {/*
                      Cue panel surface — mounted ONCE outside <App /> so it
                      survives every route change. <App /> only owns trigger
                      placements; they toggle this surface via the shared
                      Zustand store inside the wx-system UMD bundle.
                      See HRAI-1928 / HRAI-1929 for the architectural fix.
                    */}
                    <WxCueRootHost />
                    <HireUniversalSearch />
                    <App />
                  </WxCopilotLayoutProvider>
                </ErrorBoundary>
              </ConnectedRouter>
            </LanguageProvider>
          </CssBaseline>
        </ThemeProvider>
      </PostHogRootProvider>
    </Provider>,
    MOUNT_NODE,
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

render(translationMessages);

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
// if (NODE_ENV === 'production') {
//   require('offline-plugin/runtime').install(); // eslint-disable-line global-require
// }
